/* eslint-disable max-len */
import React from 'react';

const PickedIcon = props => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g id="Desktop-Flow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Assets_BUTTON-PLUGIN" transform="translate(-75.000000, -308.000000)">
        <rect fill="transparent" x="0" y="0" width="534" height="448" />
        <g id="Group" transform="translate(75.000000, 308.000000)" stroke="#FFFFFF">
          <g id="Picked" transform="translate(1.000000, 1.000000)">
            <circle id="Oval" fill="currentColor" fillRule="evenodd" cx="9" cy="9" r="9" />
            <polyline
              id="Path-8"
              strokeLinecap="round"
              transform="translate(8.736899, 8.848516) rotate(8.000000) translate(-8.736899, -8.848516) "
              points="4.55903894 9.75314099 9.07680362 13.1575209 12.9147592 4.53951081"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PickedIcon;
